import { createSelector } from '@ngrx/store';

import { RootState } from '../root-store/root.state';

export const selectSeReportFeatureState = (state: RootState) => state.report;

export const selectSeReportCurrentExaminationIds = createSelector(
    selectSeReportFeatureState,
    (state) => state.currentExaminationIds,
);

export const selectSeReportIsModified = createSelector(selectSeReportFeatureState, (state) => state.isModified);

export const selectSeReportIsPreview = createSelector(selectSeReportFeatureState, (state) => state.isPreview);

export const selectSeReportIsReadonly = createSelector(selectSeReportFeatureState, (state) => state.isReadonly);

export const selectSeReportKeyImages = createSelector(selectSeReportFeatureState, (state) => state.keyImages);

export const selectSeReportPatientId = createSelector(selectSeReportFeatureState, (state) => state.patientId);

export const selectSeReportImagesPerRowInPlaceholder = createSelector(selectSeReportFeatureState, (state) => state.imagesPerRowInPlaceholder);

export const selectSeReportImportConclusions = createSelector(selectSeReportFeatureState, (state) => state.conclusions);

export const selectSeReportExaminationStudies = createSelector(
    selectSeReportFeatureState,
    (state) => state.examinationStudies,
);

// Metodo per capire se siamo in WL ( = false) o dentro una CP ( = true)
export const selectSeReportIsAnyExaminationActive = createSelector(
    selectSeReportCurrentExaminationIds,
    (currentExaminationIds) => Object.values(currentExaminationIds).some(exs => exs.length > 0),
);

